import PropTypes from 'prop-types';

export const propTypes = {
	drawer: PropTypes.node,
	items: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.string, PropTypes.object])
	).isRequired,
	twoLine: PropTypes.bool,
};
